function cov_2toe02vd4() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx";
  var hash = "72041442b3e34f54c977368f76fad762394028d3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/ErrorPrompt.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 55
        },
        end: {
          line: 24,
          column: 1
        }
      },
      "1": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 23,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 55
          },
          end: {
            line: 12,
            column: 56
          }
        },
        loc: {
          start: {
            line: 12,
            column: 72
          },
          end: {
            line: 24,
            column: 1
          }
        },
        line: 12
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "72041442b3e34f54c977368f76fad762394028d3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2toe02vd4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2toe02vd4();
import React from 'react';
import { Text } from '@opendoor/bricks-next';
/**
 * Custom ErrorPrompt component to replace legacy Bricks ErrorPrompt
 */
cov_2toe02vd4().s[0]++;
export var ErrorPrompt = function ErrorPrompt(_ref) {
  var message = _ref.message;
  cov_2toe02vd4().f[0]++;
  cov_2toe02vd4().s[1]++;
  return /*#__PURE__*/React.createElement(Text, {
    "data-testid": "error-prompt",
    tag: "span",
    typography: "$bodySmall",
    color: "$contentStateErrorDefault",
    marginTop: "$1dot5x"
  }, message);
};
//# sourceMappingURL=ErrorPrompt.mjs.map